import React from 'react';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { useOverview } from './useOverview';
import { Tasks } from '../../../../components/Tasks/Tasks';
import { useChartReflow } from '../../../../hooks/useChartReflow';
import { RetirementChart } from '../../components/RetirementChart/RetirementChart';
import { LegendKey } from '../../../../../../CommonComponents/OPL/charts/LegendKey/LegendKey';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { PDFTitle } from '../../../../../../PDFRenderer/components/PDFTitle/PDFTitle';

interface OverviewProps {
  goalId?: string;
  isPrint?: boolean;
  title?: string;
}

export const Overview = ({ goalId, isPrint, title }: OverviewProps) => {
  const { data } = useOverview({ goalId, isPrint });
  const { chartRef } = useChartReflow();

  if (!data) {
    return null;
  }

  const {
    chartData,
    proposedPlanName,
    currentPlanTooltip,
    proposedPlanTooltip,
    isCurrentPlanSelected,
  } = data;

  const Wrapper = isPrint ? Box : React.Fragment;

  return (
    <Wrapper>
      <PDFTitle title={title} />

      <Card p={16}>
        <Text variant="cardTitle" mb="24" as="h2">
          Retirement Assets
        </Text>

        <RetirementChart
          ref={chartRef}
          data={chartData}
          isCurrentPlan={isCurrentPlanSelected}
          isPrint={isPrint}
        />

        {!isCurrentPlanSelected && (
          <Box display="flex" justifyContent="center">
            <LegendKey text="Current Plan" tooltipContent={currentPlanTooltip} />
            <LegendKey
              dotBorderColor="primary.500"
              dotColor="primary.100"
              ml="24"
              text={proposedPlanName}
              tooltipContent={proposedPlanTooltip}
            />
          </Box>
        )}
      </Card>

      <Tasks goalId={goalId} />
    </Wrapper>
  );
};
